import {
    cursorLogic
} from "./components/cursor";
import header from "./components/header";
import popups from "./components/popups";
import signup from "./components/signup";
import sliders from "./components/sliders";
import accordion from "./components/faq-accordion";
import scrollTo from "./components/scroll-to";
import pdf from "./components/pdf";
import scrollbar from "./components/scrollbar";
import preloader from "./components/preloader";
import moreAnimate from "./components/moreAnimate";
import animation from "./components/animation";
import gallery from "./components/gallery";
import footer from "./components/footer-accordion";
import goback from "./components/goback";
import circleCenterAnimation from "./components/circle-center-animation";
import team from "./components/team";
import filterList from "./components/filter-list";
import dropdown from "./components/dropdown";
import map from "./components/map";
import isTouch from "./helpers/isTouch";
// import pyro from "./components/pyro";
import partnersMobile from "./components/partners-mobile";
import ratesAccordion from "./components/rates-accordion";
import ratesTabs from "./components/rates-tabs";
import loadMore from "./components/load-more";
import trueLoadmore from "./components/true-loadmore";
import press from "./components/press";
import setFullHeight from "./helpers/setFullHeight";
import {
    isSafari
} from "./components/exportFunc";
import {
    isSafariMobile
} from "./components/exportFunc";
import mailchimpSend from './helpers/mailchimp-send';
import contactForm from './components/contact-form';
import lazy from "./helpers/lazy";
export default () => {
    setFullHeight();
    scrollbar();
    preloader();
    goback();
    gallery();
    cursorLogic();
    header();
    signup();
    sliders();
    popups();
    accordion();
    scrollTo();
    pdf();
    moreAnimate();
    footer();
    setTimeout(() => {
        animation()
    }, 2500);
    goback();
    circleCenterAnimation();
    team();
    filterList();
    dropdown();
    map();
    // pyro();
    partnersMobile();
    ratesTabs();
    // ratesAccordion();
    isSafariMobile() ? document.body.classList.add('safari-wrapper') : false;
    isTouch() ? document.documentElement.classList.add('touch') : document.documentElement.classList.add('no-touch');
    isSafari() ? document.body.classList.add('is-safari') : false;
    loadMore();
    trueLoadmore();
    press();
    mailchimp();
    contactForm();
    lazy();

    function mailchimp() {
        let forms = document.querySelectorAll('.js-subscribe-form');

        if (forms.length) {
            forms.forEach(function(form) {
                mailchimpSend(form);
            });
        }
    }
}